<template>
  <div class="ak-basic-tree">
    <ul>
      <ak-tree-item
        v-for="(child, index) in data"
        :key="index"
        :data="child.data"
        :children="child.children"
        :show-empty="showEmpty"
      >
        <template #default="{ item }">
          <slot :item="item" />
        </template>
        <template #empty>
          <slot name="empty" />
        </template>
      </ak-tree-item>
    </ul>
  </div>
</template>

<script>
import { defineComponent, provide } from 'vue'
import TreeItem from './TreeItem.vue'
export default defineComponent({
  name: 'AkTree',
  components: {
    [TreeItem.name]: TreeItem,
  },
  props: {
    /**
     * @type {Array}
     * @description The tree data
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * @type {Boolean}
     * @description Should display empty tree contents
     */
    showEmpty: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {Function}
     * @description A function to check if an item is a tree or not
     */
    isTree: {
      type: Function,
      default: () => {
        return true
      },
    },
  },
  emits: ['click', 'clickEmpty'],
  setup(props, { emit }) {
    /**
     * @param {Object} item
     * @description when an item in the tree is clicked
     */
    const clickTreeItem = (item) => {
      emit('click', item)
    }

    /**
     * @param {Object} parent
     * @description when an empty item is clicked
     */
    const clickEmptyTreeItem = (parent) => {
      emit('clickEmpty', parent)
    }

    /**
     * @description Provide functions used in tree item
     */
    provide('clickTreeItem', clickTreeItem)
    provide('clickEmptyTreeItem', clickEmptyTreeItem)
    provide('isTree', (item) => {
      return props.isTree(item)
    })
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-basic-tree {
  ul {
    padding-left: $spacing-tiny;
    list-style: none;
  }
}
</style>
